import { css } from 'design'
import { Stack } from 'primitives/containers'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'

import { CommunicationOptions } from '../../components/live_chat_widget/communication_options'
import { LiveChatPreview } from '../../components/live_chat_widget/live_chat_preview'
import { PoweredByFooter } from '../../components/live_chat_widget/powered_by_footer'
import { WelcomeMessage } from '../../components/live_chat_widget/welcome_message'
import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'
import { Stack as StackImg } from '../../images/index'
import { getLiveChatTopics } from '../../reduxes/slices/topics/selectors'
import { AppLocationContext, WIDGET_VIEW } from '../admin/app_location_provider'

export const LandingPage = () => {
  const { setAppLocation } = useContext(AppLocationContext)
  const topics: any = useSelector(getLiveChatTopics)

  const viewPastConversations = () => {
    setAppLocation({
      widgetView: WIDGET_VIEW.PAST_CONVERSATIONS,
    })
  }

  return (
    <>
      <WidgetHeaderBar>
        <WelcomeMessage>
          {!!topics.length && (
            <Stack
              gap={2}
              css={{
                position: 'relative',
                '>:first-child': {
                  fontSize: '$3',
                },
                maxWidth: 400,
              }}
            >
              <span>
                {topics.length === 1
                  ? 'Continue the conversation'
                  : `Past conversations (${topics.length})`}
              </span>
              <LiveChatPreview
                topic={topics[0]}
                {...(topics.length > 1 && {
                  onClick: viewPastConversations,
                })}
                className={liveChatPreviewStyles()}
              />
              {topics.length > 1 && <StackImg className={stackImageStyles()} />}
            </Stack>
          )}
        </WelcomeMessage>
      </WidgetHeaderBar>
      <div className={spacerStyles()} />
      <CommunicationOptions />
      <PoweredByFooter />
    </>
  )
}

const stackImageStyles = css({
  position: 'absolute',
  bottom: '-10px',
  left: '5%',
  width: '90%',
  height: 'auto',
})

const liveChatPreviewStyles = css({
  pointerEvents: 'auto',
  zIndex: 1,

  '.topic__theme--dark &': {
    background: 'white !important',
    color: '$grey50 !important',
  },
})

const spacerStyles = css({
  flexGrow: 1,
})
